import { Navigate, Outlet, useLocation } from "react-router-dom";
import { CircularProgress, Box } from "@mui/material";
import { useAuth } from "../contexts/AuthContext";
import { usePendingUser } from "../contexts/PendingUserContext";

// protects authenticated/terms-accepted routes, shows loading while validating, and redirects to login if not authenticated
function PrivateRoute() {
  const { user, loading } = useAuth();
  const { termsAccepted } = usePendingUser();
  const location = useLocation();

  // show loading spinner while auth is being restored from localStorage
  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          width: "100%",
        }}
      >
        <CircularProgress sx={{ color: "var(--role-accent)" }} />
      </Box>
    );
  }

  // if not authenticated or terms not accepted, redirect to login
  if (!user || !termsAccepted) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // user is authenticated and terms accepted, render the protected route
  return <Outlet />;
}

export default PrivateRoute;
